// import { Checkbox } from '@material-ui/core'
import { Checkbox, CheckboxChangeEvent } from '@progress/kendo-react-inputs'
import { AutoComplete } from '@progress/kendo-react-dropdowns'
import React, { ChangeEvent, useEffect, useState } from 'react' //, useCallback
import { CustomCheckbox } from '../../EDIForms/Components/FormInput'
import './ShopMonitor.scss'

export interface CustomerInfo {
    ShipToName: string
    ShipToCity: string
    CustomerAccountCode: string
}
export interface FilterCustomerCheckBoxProps {
    title: string
    selected: CustomerInfo[]
    handleSelectedChange: (list: CustomerInfo[]) => void
    checkboxList: CustomerInfo[]
    checkboxWidth: number
}

export const FilterCustomerCheckBox = (props: FilterCustomerCheckBoxProps) => {
    const [checked, setChecked] = useState(props.selected)

    const handleCheck = (event: any) => {
        var updatedList = [...checked]

        if (event.target.checked) {
            updatedList = [...checked, event.target.value]
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1)
        }

        setChecked(updatedList)
    }

    return props.checkboxList.length > 0 ? (
        <div style={{ width: props.checkboxWidth }}>
            <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 500 }}>{props.title}</div>
            <div className="filterCheckBoxContainer">
                {props.checkboxList.map((item: CustomerInfo, index: number) => (
                    <div
                        key={index}
                        style={{
                            position: 'relative',
                            display: 'flex',
                            height: 20,
                            verticalAlign: 'middle',
                            whiteSpace: 'nowrap',
                            backgroundColor: props.selected.includes(item) ? '#0062FF33' : '',
                        }}
                    >
                        <div>
                            <Checkbox
                                value={
                                    (item.ShipToName ? item.ShipToName.trim() : '') +
                                    (item.ShipToCity ? ', ' + item.ShipToCity.trim() : '') +
                                    (item.CustomerAccountCode
                                        ? ' (' + item.CustomerAccountCode.trim() + ')'
                                        : '')
                                }
                                color="default"
                                checked={props.selected.includes(item)}
                                style={{
                                    borderColor: '#0062FF',
                                    transform: 'scale(0.75)',
                                }}
                                onChange={(event: CheckboxChangeEvent) => {
                                    handleCheck(event)

                                    if (event.value) {
                                        if (item) {
                                            if (
                                                !props.selected.find(
                                                    (o: CustomerInfo) =>
                                                        o.ShipToName === item.ShipToName &&
                                                        o.ShipToCity === item.ShipToCity &&
                                                        o.CustomerAccountCode ===
                                                            item.CustomerAccountCode
                                                )
                                            ) {
                                                const tempList = props.selected
                                                tempList.push(item)
                                                props.handleSelectedChange(tempList)
                                            }
                                        }
                                    } else {
                                        if (item) {
                                            let tempList = props.selected
                                            tempList = tempList.filter(
                                                (temp: CustomerInfo) => temp !== item
                                            )
                                            props.handleSelectedChange(tempList)
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div style={{ fontWeight: 500, marginTop: 1 }}>
                            {(item.ShipToName ? item.ShipToName.trim() : '') +
                                (item.ShipToCity ? ', ' + item.ShipToCity.trim() : '') +
                                (item.CustomerAccountCode
                                    ? ' (' + item.CustomerAccountCode.trim() + ')'
                                    : '')}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    ) : (
        <div style={{ width: props.checkboxWidth }}>
            <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 500 }}>{props.title}</div>
            <div className="filterCheckBoxContainer"></div>
        </div>
    )
}

export interface FilterCheckBoxProps {
    title: string
    selected: string[]
    handleSelectedChange: (list: string[]) => void
    checkboxList: string[]
    checkboxWidth: number
}

export const FilterCheckBox = (props: FilterCheckBoxProps) => {
    const [checked, setChecked] = useState(props.selected)

    const handleCheck = (event: any) => {
        var updatedList = [...checked]
        if (event) {
            updatedList = [...checked, event.target.value]
        } else {
            updatedList.splice(checked.indexOf(event.target.value), 1)
        }

        setChecked(updatedList)
    }

    return props.checkboxList.length > 0 ? (
        <div style={{ width: props.checkboxWidth }}>
            <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 500 }}>{props.title}</div>
            <div className="filterCheckBoxContainer">
                {props.checkboxList.map((item: string, index: number) => (
                    <div
                        key={index}
                        style={{
                            display: 'flex',
                            verticalAlign: 'middle',
                            height: 20,
                            position: 'relative',
                            whiteSpace: 'nowrap',
                            backgroundColor: props.selected.includes(item) ? '#0062FF33' : '',
                        }}
                    >
                        <div>
                            <Checkbox
                                value={item}
                                color="default"
                                checked={props.selected.includes(item)}
                                style={{
                                    borderColor: '#0062FF',
                                    transform: 'scale(0.75)',
                                }}
                                onChange={(event: CheckboxChangeEvent) => {
                                    handleCheck(event)

                                    if (event.value) {
                                        if (item) {
                                            if (!props.selected.find((o: string) => o === item)) {
                                                const tempList = props.selected
                                                tempList.push(item)
                                                props.handleSelectedChange(tempList)
                                            }
                                        }
                                    } else {
                                        if (item) {
                                            let tempList = props.selected
                                            tempList = tempList.filter(
                                                (temp: string) => temp !== item
                                            )
                                            props.handleSelectedChange(tempList)
                                        }
                                    }
                                }}
                            />
                        </div>
                        <div style={{ marginTop: 1, fontWeight: 500 }}>{item}</div>
                    </div>
                ))}
            </div>
        </div>
    ) : (
        <div style={{ width: props.checkboxWidth }}>
            <div style={{ marginBottom: 10, fontSize: 16, fontWeight: 500 }}>{props.title}</div>
            <div className="filterCheckBoxContainer"></div>
        </div>
    )
}
